import React from 'react'
import { RouteProps } from 'react-router-dom'

import Cookies from '../cookies/Container'
import FooterForm from '../footer-form/Container'
import Hero from '../hero/Container'
import HowItWorks from '../how-it-works/Container'
import Map from '../map/Container'
import Meals from '../meals/Container'
import OneDollarLunchPromo from '../one-dollar-lunch-promo/Container'
import Plans from '../plans/Container'
import SEO from '../seo'
import SingleTestimonial from '../single-testimonial/Container'
import Testimonials from '../testimonials/Container'

interface Props extends RouteProps<'/nylunch' | '/joinnow' | '/*' | '/sflunch'> {
  isSimpleHero: boolean
}

const LandingContainer: React.FC<Props> = ({ isSimpleHero }) => {
  return (
    <>
      <SEO title="Home" />
      <Hero isFormRequired={!isSimpleHero} phoneForm={false} />
      <Meals isDelivery={false} />
      <Map />
      <Plans />
      <HowItWorks />
      <SingleTestimonial />
      <Testimonials />
      <FooterForm />
      <OneDollarLunchPromo />
      <Cookies />
    </>
  )
}

export default LandingContainer
